module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/354.7904c040.png";